import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from 'react/components/Modal';
import { getResourceTo } from 'react/utils/utils';
import { LookupField, GroupField, TextField } from 'react/components/fields';

const LocaleKeyFieldsModal = ({ closeModalFn, modalIsOpen }) => {
  const buttonLabel = getResourceTo('samlConfiguration.button.close');
  const localeModalSubtitle = getResourceTo(
    'i18nLocaleMappingModal.label.subtitle'
  );

  const Footer = () => (
    <>
      <input type="button" value={buttonLabel} onClick={closeModalFn} />
    </>
  );

  return (
    <Modal
      className="fieldMappingModal"
      isOpen={modalIsOpen}
      title={Monet.I18n.getResourcesByKey('i18nLocaleMappingModal.label.title')}
      closeModalFn={closeModalFn}
      crossAxisBtn={false}
      footer={<Footer />}
    >
      <p className="fieldMappingModal-label">{localeModalSubtitle}</p>
      <GroupField name="idp.i18nLocaleMappings">
        <TextField
          label="samlConfiguration.identityProviderLocale"
          description="assertionFieldName"
          name="assertionFieldName"
        />
        <div className="arrowRight" />
        <LookupField
          label="samlConfiguration.greenmileLocale"
          name="value"
          lookupEntity="I18NLocale"
          lookupEntityColumn="description"
        />
      </GroupField>
    </Modal>
  );
};

LocaleKeyFieldsModal.propTypes = {
  closeModalFn: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  modalIsOpen: state.samlConfiguration.getIn(
    ['modals', 'localeKey', 'modalIsOpen'],
    false
  )
});

export default connect(mapStateToProps)(React.memo(LocaleKeyFieldsModal));
